import React from 'react';
import { TranslationsProvider } from '../../context/TranslationContext';
import ApplicantEvaluationProvider from '../context';
import ApplicantEvaluation from '../';
import '../index.less';

const ApplicantEvaluationWrapper = ({ translations, applicantId, onEvaluationUpdated }) => {
    return (
        <TranslationsProvider translations={translations}>
            <ApplicantEvaluationProvider applicantId={applicantId} onEvaluationUpdated={onEvaluationUpdated}>
                <ApplicantEvaluation />
            </ApplicantEvaluationProvider>
        </TranslationsProvider>
    );
};

export default ApplicantEvaluationWrapper;
